import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Title class.
 */
export default class Circle extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Circle',
  };

  /**
   *
   */
  mounted() {
    gsap.to(this.$el, {
      ease: 'none',
      rotate: 180,
      scrollTrigger: {
        trigger: this.$el,
        start: 'top bottom',
        end: '+=100% top',
        scrub: true,
      },
    });
  }
}
